/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define(['doT',
	'../../../../lib/@waca/core-client/js/core-client/ui/core/View',
	'../../../../lib/@waca/core-client/js/core-client/utils/Deferred',
	'jquery',
	'text!./SizeIndicator.html'],
function( dot, BaseView, Deferred, $, SizeIndicatorTemplate) {

	var LayoutIndicator = null;
	LayoutIndicator = BaseView.extend({

		OFFSET: 25,

		init: function(options) {
			LayoutIndicator.inherited('init', this, arguments);
			this.$node = options.node;
		},

		render: function() {
			const template = dot.template(SizeIndicatorTemplate);
			const layoutIndicatorHtml = template();
			this.$el = $(layoutIndicatorHtml);
			this.$node.prepend(this.$el);
			this.$content = $(this.$el.find('.sizeDashboardIndicatorText')[0]);
		},

		updatePosition: function(position, containerOffset, vertical){
			let relativeMouseY = 0;
			let relativeMouseX = 0;

			relativeMouseY = position.top + this.$node.scrollTop() - containerOffset.top;
			relativeMouseX = position.left + this.$node.scrollLeft() - containerOffset.left;

			if((relativeMouseY-this.OFFSET) >= 0){
				if(vertical){
					this.$el.addClass('vertical');
					this.$el.css({ top: relativeMouseY, left: relativeMouseX + position.width + this.OFFSET });
				}else{
					this.$el.css({ top: relativeMouseY - this.OFFSET, left: relativeMouseX });
				}
			}else{
				if(vertical){
					if(relativeMouseX >= 0){
						this.$el.addClass('vertical');
						this.$el.css({ top: relativeMouseY, left: relativeMouseX + position.width + this.OFFSET });
					}else{
						this.$el.hide();
					}
				}else{
					this.$el.css({ top: relativeMouseY + position.height + (this.OFFSET/2), left: relativeMouseX });
				}
			}
		},

		updateContent: function(size, displaySize){
			this.$content.text(displaySize);
			this.$el.width(size);
		},

		remove: function(){
			this.$el.remove();
		},

		show: function(){
			this.$el.show();
		},

		hide: function(){
			this.$el.hide();
		}

	});

	return LayoutIndicator;
});
